import React, { useState } from 'react';
import { toast } from 'sonner';
import { Layers, Loader2 } from 'lucide-react';
import { api } from '../lib/api';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { useImportCategories, invalidateImportCategories } from './DealFilterPanel';
import { useAuth } from '../contexts/AuthContext';

// Import category of a deal (Talu, 22.10.2026): chip in the deal header; admins can re-assign older stock.
export function ImportCategoryChip({ project, onSaved }) {
  const { isAdmin } = useAuth();
  const cats = useImportCategories();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const cat = project?.import_category;
  if (!cat && (!isAdmin || !cats.length)) return null;

  const chip = (
    <span data-testid="import-category-chip" title={cat ? `Import-Kategorie · Start-Stufe ${cat.stage === 'ai_reviewed' ? 'OLTA TAM' : 'Succession Possible'}` : 'Kategorie zuordnen'}
      className={`inline-flex items-center gap-1 text-[9px] font-mono rounded px-1.5 py-0.5 border shrink-0 ${cat
        ? 'text-sky-300 border-sky-500/40 bg-sky-500/10'
        : 'text-muted-foreground/70 border-dashed border-border hover:text-foreground'} ${isAdmin ? 'cursor-pointer' : ''}`}>
      <Layers className="w-3 h-3" /> {cat ? cat.name : '+ Kategorie'}
    </span>
  );
  if (!isAdmin) return chip;

  const choose = async (id) => {
    setBusy(true);
    try {
      const r = await api.setProjectImportCategory(project.id, id);
      invalidateImportCategories();
      toast.success(r.data.import_category ? `Kategorie „${r.data.import_category.name}“ gesetzt` : 'Kategorie entfernt');
      setOpen(false); onSaved && onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || 'Speichern fehlgeschlagen'); }
    setBusy(false);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild><button data-testid="import-category-edit-btn">{chip}</button></PopoverTrigger>
      <PopoverContent align="start" className="w-60 p-1 bg-card border-border rounded-sm" data-testid="import-category-popover">
        <p className="text-[9px] uppercase tracking-widest text-muted-foreground/70 font-bold px-2 py-1">Import-Kategorie</p>
        {busy && <Loader2 className="w-3 h-3 animate-spin mx-2 text-muted-foreground" />}
        {cats.map(c => (
          <button key={c.id} onClick={() => choose(c.id)} disabled={busy} data-testid={`import-category-opt-${c.id}`}
            className={`w-full text-left text-xs px-2 py-1.5 rounded-sm hover:bg-secondary ${cat?.id === c.id ? 'text-sky-300' : 'text-foreground'} ${c.archived ? 'opacity-60' : ''}`}>
            {c.name}{c.archived ? ' (archiviert)' : ''}
          </button>
        ))}
        {cat && (
          <button onClick={() => choose(null)} disabled={busy} data-testid="import-category-opt-none"
            className="w-full text-left text-xs px-2 py-1.5 rounded-sm hover:bg-secondary text-muted-foreground border-t border-border/60 mt-0.5">
            Ohne Kategorie
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
}
